import {create} from 'zustand';

interface PartnerHandoffStore {
  pendingUrl: string | null;
  requestHandoff: (url: string) => void;
  dismissHandoff: () => void;
}

export const usePartnerHandoffStore = create<PartnerHandoffStore>()(set => ({
  pendingUrl: null,
  requestHandoff: url => set({pendingUrl: url}),
  dismissHandoff: () => set({pendingUrl: null}),
}));

export const requestPartnerHandoff = (url: string) =>
  usePartnerHandoffStore.getState().requestHandoff(url);
